import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import BtnExcel from '../../Components/BtnExcel';
import { useNavigate } from 'react-router-dom';
import { formatDate, getTodayDateISO } from '../../Utils/Common';
import { 
  Layout,
  Col, 
  Row,
  Button,
  Dropdown, 
  Space,
  Modal,
  Form,
  Tag,
  Input,
} from 'antd';
import { 
  ExclamationCircleFilled, 
  CheckCircleOutlined, 
} from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { Search } = Input;
const { confirm } = Modal;

const Owner = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);
  const [ownerDetails, setOwnerDetails] = useState([])
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [excelData, setExcelData] = useState([])
  const [filterConfig, setFilterConfig] = useState({
    search: '',
    type: '',
    owner_id: '',
    page: 1,
  })

  const [ownerData, setOwnerData] = useState([])
  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const { callPost, loading} = usePostRequest(()=>{
    fetchAllOwner()
    addForm.resetFields();
    editForm.resetFields();
  });

  function ActionBtn(data) {
    const items = [
        {
            label: (
                <div onClick={()=>showViewModal(data.row)}>
                    View
                </div>
            ),
            key: '1',
        },
        {
            label: (
                <div onClick={()=>navigate('/owner/edit/' + data.row.id)}>
                    Edit
                </div>
            ),
            key: '2',
        },
        {
            label: (
                <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(data.row.id)}>
                    Delete
                </div>
            ),
            key: '3',
        },
    ];

    return (
      <>
        <span className='center'>
          <Dropdown
            menu={{
            items,
            }}
            trigger={['click']}
          >
            <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
              <Space>
                <MoreVert />
              </Space>
            </div>
          </Dropdown>
        </span>
      </>
    );
  };
  const showViewModal = (owner_data) => {
    setOwnerDetails(owner_data); 
    setViewVisible(true);
  };

  async function fetchAllOwner () {
    setIsLoading(true)
    const response = await UseGetRequest("owners/get", filterConfig);
    if (response?.data) {
      const owner_data = response?.data?.data?.map((data) => ({
        id: data.id,
        name: data.name,
        address: data.address,
        contact_no: data.contact_no,
        email: data.email,
        other_contact_email: data.other_contact_email,
        account_name: data.account_name,
        bank_name: data.bank_name,
        bank_number: data.bank_number,
        added_by: data.added_by,
        added_on: data.added_on,
        updated_by: data.updated_by,
        updated_on: data.updated_on,
        rental_unit: data?.properties?.map((data) => (
          <Row>
            <Col className='mb-2'>
              <Tag icon={<CheckCircleOutlined />} color="default">{data.property}</Tag>
            </Col>
          </Row>
        )),
        parking_unit: data?.parking_units?.map((data) => (
          <Row>
            <Col className='mb-2'>
              <Tag icon={<CheckCircleOutlined />} color="default">{data.property}</Tag>
            </Col>
          </Row>
        )),
      }))

      setOwnerData(owner_data);
      setPageSize(response?.data?.size)
    } else {
      setOwnerData([])
      setPageSize('')
    }
    setIsLoading(false);
  }

  async function fetchExportData () {
    setExportLoading(true)
    const response = await UseGetRequest("owners/get", 
      {
        search: filterConfig.search,
        type: filterConfig.type,
        owner_id: filterConfig.owner_id,
      }
    );
    if (response?.data) {
      const excel_data = response?.data?.data?.map((data) => ({
        id: data.id,
        name: data.name,
        address: data.address,
        contact_no: data.contact_no,
        email: data.email,
        account_name: data.account_name,
        bank_name: data.bank_name,
        bank_number: data.bank_number,
        added_on: data.added_on && formatDate(data.added_on),
        updated_on: data.updated_on && formatDate(data.updated_on),
      }))
  
      setExcelData(excel_data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }
 
  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Do you want to permanently remove this owner?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        callPost(
          "owners/delete", 
          {owner_id: id},
          false
        );
      },
    });
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchAllOwner();
    fetchExportData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
        <Navbar navKey={'owner_nav'}/>
        <Layout className='content-container'>
          <Row className='custom-padding responsive-tab-inline'>
            <Col span={9} className='header-container'>
              OWNER
            </Col>
            <Col span={15} className='mt-2 responsive-tab-width' align='end'>
              <Space className='responsive-inline'>
                <BtnExcel
                  label={"Export to Excel"}
                  size={"sm"}
                  excelData={excelData}
                  xlsxHeaders={[
                    "ID",
                    "Owner Name",
                    "Home Address",
                    "Contact Number",
                    "Email",
                    "Acount Name",
                    "Bank Name",
                    "Bank Number",
                    "Added On",
                    "Updated On",
                  ]}
                  handleData={fetchExportData}
                  isClicked={exportLoading}
                  fileName={`Owners_${getTodayDateISO()}.xlsx`}
                />
                        
                <Button 
                  className='button-color responsive-btn-two' 
                  onClick={() => navigate('/owner/add')} 
                  type="primary"
                >
                  + Add Owner
                </Button>
              </Space>
            </Col>
          </Row>
          <Row>
            <Space span={24} className='responsive-inline excel-row'>
              <Search
                placeholder="Search..."
                size='medium'
                onSearch={(e)=>handleSearchChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />              
            </Space>
          </Row>
          <Row className='page-content'>
            <Col span={24} className='responsive-overflow-auto'>
              <AntDTable
                tableHeaders={[
                  "Owner Name",
                  "Rental Unit",
                  "Parking Unit",
                  "Contact Number",
                  "Email",
                  "Home Address",
                ]}
                headerSelector={[
                  "name",
                  "rental_unit",
                  "parking_unit",
                  "contact_no",
                  "email",
                  "address",
                ]}
                tableData={ownerData}
                ActionBtn={(row) => ActionBtn(row)}
                withAction={true}
                loading={isLoading}
                tablePages={10}
                handleTableChange={handleTableChange}
                filterConfig={filterConfig}
                totalSize={pageSize}
                isSearch={true}
              />
            </Col>
          </Row>
        </Layout>
        <Modal
          title="View Property"
          confirmLoading={loading}
          open={viewVisible}
          // onOk={handleEditOk}
          onCancel={() => setViewVisible(false)}
          okText="Save"
          maskClosable={false}
          width={800}
          footer={null} 
        >
          <Row className='mb-4'>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Owner Name: </div>
                  {ownerDetails.name}
                </Space>
            </Col>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Owner Address: </div>
                  {ownerDetails.address}
                </Space>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Email </div>
                  {ownerDetails.email}
                </Space>
            </Col>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Contact Number: </div>
                  {ownerDetails.contact_no}
                </Space>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Bank Name: </div>
                  {ownerDetails.bank_name}
                </Space>
            </Col>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Bank  Number: </div>
                  {ownerDetails.bank_number}
                </Space>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Account Name: </div>
                  {ownerDetails.account_name}
                </Space>
            </Col>
            <Col span={12}>
                <Space direction='vertical'>
                  <div className='view-text'>Other Contact Info: </div>
                  {ownerDetails.other_contact_email}
                </Space>
            </Col>
          </Row>
        </Modal>
    </Layout>
  )
}

export default Owner
